import * as React from "react";
import SelectAddressModalForm from "../../Forms/buypermits/SelectAddressModalForm";
import BaseModal, { BaseModalContent } from "../BaseModal";

const SelectAddressModal=(props)=>{ 
   const {isOpenSelectAddressModal,CloseSelectAddressModal,handleOpenAddAddressModal} = props;

//    useEffect(() => {
//     const ActiveData = emailData && emailData.filter((items) => {
//       return items.inactive === false
//     })
//     setMyEmailData(ActiveData)
//     dispatch(getCheckoutSelectAddressStates({accountId:1337}));
//   }, [emailData])

   
    return(
        <>
            <BaseModal
                title="Select Address"
                align="center"
                open={isOpenSelectAddressModal}
                onClose={CloseSelectAddressModal}
                with={500}                
            >
                <BaseModalContent>
                   <SelectAddressModalForm 
                      CloseSelectAddressModal={CloseSelectAddressModal}
                      handleOpenAddAddressModal={handleOpenAddAddressModal}
                   />
                </BaseModalContent>
            </BaseModal>
        </>
    )
}
export default SelectAddressModal;